
import { Component, Prop, Vue } from 'vue-property-decorator';
import CheckBox from '../utils/CheckBox.vue';
import { ICellRendererParams } from 'ag-grid-community/dist/lib/rendering/cellRenderers/iCellRenderer';

@Component({ components: { CheckBox } })
export default class CheckBoxCellRenderer extends Vue {
  params!: ICellRendererParams;
}
